module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To anyone"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nwho works with or talks to the press."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nIt may not be easy,"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nbut at all times a free press helps keep"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nour nation free.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0582a809","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061755149_dedication.vue
// module id = 63
// module chunks = 0